window.addEventListener("load", () => {
    Prism.languages.spintax = {
        group: {
            pattern: /\{[^{}]*\}/,
            inside: {
                punctuation: /[{}]/,
                operator: /\|/,
                weight: {
                    pattern: /:\s*\d+(?:\.\d+)?/,
                    alias: "number"
                },
                option: {
                    pattern: /[^{}|:]+/,
                    alias: "string"
                }
            }
        }
    };
});